import { getToken, isSupported, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { SAVE_FCM_TOKEN_URL } from "./redux/api/config";
import { ACCESS_TOKEN } from "./constants/AppVarConstants";
import { emitForegroundFcmMessage } from "./utils/fcmForegroundEvents";
import { buildFcmDevicePayload } from "./utils/deviceInfo";

let foregroundListenerRegistered = false;

/** Handles messages while the SeeVi tab is open and focused. */
export function setupForegroundMessaging() {
  if (foregroundListenerRegistered) return;
  foregroundListenerRegistered = true;

  isSupported().then((supported) => {
    if (!supported) {
      console.warn("[FCM] Messaging not supported in this browser");
      return;
    }

    onMessage(messaging, (payload) => {
      console.log("[FCM] Foreground message received:", payload);
      emitForegroundFcmMessage(payload);
    });

    console.log("[FCM] Foreground message listener registered");
  });
}

const VAPID_KEY =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BBTbJKskP1gzEhmYPKDrSWgjt4eFoHDoJi1TqpFThj3DQdjf91BxggiPClBomNNFSAzJSGGDeQ4Hh7v4Vf2WEqQ";

async function getMessagingServiceWorkerRegistration() {
  if (!("serviceWorker" in navigator)) {
    return null;
  }

  let registration = await navigator.serviceWorker.getRegistration("/firebase-messaging-sw.js");
  if (!registration) {
    registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  }

  await navigator.serviceWorker.ready;
  return registration;
}

export async function enableNotifications() {
  try {
    if (!("Notification" in window)) {
      console.warn("This browser does not support notifications.");
      return null;
    }

    const supported = await isSupported();
    if (!supported) {
      console.warn("Firebase Cloud Messaging is not supported in this browser.");
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission:", permission);
      return null;
    }

    const serviceWorkerRegistration = await getMessagingServiceWorkerRegistration();
    if (!serviceWorkerRegistration) {
      console.error("Service worker registration failed.");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    });

    if (!token) {
      console.warn("No FCM registration token returned. Check Firebase Console web push setup.");
      return null;
    }

    console.log("FCM TOKEN:", token);
    setupForegroundMessaging();

    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    const headers = { "Content-Type": "application/json" };
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    try {
      const res = await fetch(SAVE_FCM_TOKEN_URL, {
        method: "POST",
        headers,
        body: JSON.stringify(buildFcmDevicePayload(token)),
      });
      if (!res.ok) {
        console.warn("Failed to save FCM token on server:", res.status, await res.text());
      }
    } catch (saveErr) {
      console.warn("Failed to save FCM token on server:", saveErr);
    }

    return token;
  } catch (err) {
    console.error("enableNotifications failed:", err);
    return null;
  }
}
